/**
 * @desc SKU主体库存列表
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(params: API.stock.stockSku.pageListStockSku.Params, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku/company/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
